<template>
  <client-only>
    <div class="language" @mouseleave="openDialog = false">
      <div class="current" v-if="selectedLanguage">
        <div @click="openDialog = true" @mouseover="openDialog = true">
          <div
            class="flag"
            :style="[{ backgroundImage: `url(${selectedLanguage.flag_img_path})` }]"
          ></div>
        </div>
      </div>
      <div class="list" :class="{ open: openDialog }" :style="listStyle">
        <div class="">
          <ul>
            <li
              class="item"
              v-for="language in languages"
              :key="language.id"
              @click="changeLocale(language)"
            >
              <img :src="language.flag_img_path" class="flag"/>
              <span>
                {{ language.name }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import _NuxtApp from "~/types/NuxtApp";
import languages, { Language } from "~/utils/languages";

const { $EventBus, $i18n } = <_NuxtApp>useNuxtApp();

type Props = {
  displayToRight?: boolean;
};

const { displayToRight } = withDefaults(defineProps<Props>(), {
  displayToRight: false,
});

// ----------------------------- Data -----------------------------
let selectedLanguage = ref<Language | undefined>(languages[0]);
const openDialog = ref(false);

// ----------------------------- Methods -----------------------------
function changeLocale(language: Language) {
  openDialog.value = false;
  $EventBus.changeLanguage(language);
}

function languageChangedHandler(data: any) {
  const [language] = data as [Language];
  selectedLanguage.value = language;
}

// ----------------------------- Computed -----------------------------
const listStyle = computed(() => ({
  left: displayToRight ? 0 : "auto",
  right: displayToRight ? "auto" : 0,
}));

onMounted(() => {
  const selectedLanguageCode = $i18n.locale.value;
  selectedLanguage.value = languages.find(
    (l) => l.code === selectedLanguageCode
  );

  $EventBus.$on("languageChanged", languageChangedHandler);
});

onBeforeUnmount(() => {
  $EventBus.$off("languageChanged", languageChangedHandler);
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.flag {
  $SIZE: 2.5em;
  $MOBILE_SIZE: 30px;
  border-radius: 100%;

  cursor: pointer;
  height: $SIZE;
  width: $SIZE;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;

  @media (max-width: 768px) {
    height: $MOBILE_SIZE;
    width: $MOBILE_SIZE;
  }
}

.language {
  position: relative;

  .list {
    display: none;
    position: absolute;
    top: 36px;
    // width: 200px;
    height: auto;
    background-color: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    z-index: 20;

    &.open {
      display: block;
    }

    ul {
      list-style: none;
      padding: 0 0;
      margin: 0 0;

      .item {
        display: flex;
        align-content: center;
        text-align: left;
        padding: 10px 10px;
        line-height: 36px;
        cursor: pointer;
        transition: color 500ms ease, background-color 500ms ease;

        &:hover {
          background-color: var(--pallete_clear_color);
          color: var(--pallete_dark_text_color);
        }

        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
